<template>
  <b-row class="px-4">
    <b-col sm="12" class="result-summary rounded noPrint">
      <!-- {{params}} -->
      <div class="d-flex justify-content-between">
        <div class="mx-2">
          <span class="tag-details"><translate>Destination</translate>: </span> <span class="name-details">{{params.resortName}}</span>
        </div>
        <div class="mx-2">
          <span class="tag-details"><translate>Check in</translate>: </span> <span class="name-details">{{ model.params.checkIn }}</span>
        </div>
        <div class="mx-2">
          <span class="tag-details"><translate>No. nights</translate>: </span> <span class="name-details">{{duration}}</span>
        </div>
        <div v-for="(room, index) in params.rooms" :key="index" class="mx-2">
          <span class="tag-details"><translate>Room</translate> {{index + 1 }} - </span>
          <span>{{room.adults}} </span><span class="name-details"> <translate>adults</translate> </span>
          <span v-if="room.ages && room.ages.length" class="name-details">, {{ room.ages.length }} <translate>children</translate></span>
        </div>
      </div>
      <hr class="my-1"/>
      <div>
       <small class="float-right">
          <b v-translate>generated by</b> -
          <span class="name-details"> {{userData.fname}} {{userData.lname}}</span>
       </small>
     </div>
    </b-col>
    <b-col sm="12" class="result-summary rounded print-only pb-4">
      <span class="tag-details"><translate>Destination</translate>: </span> <span class="name-details">{{params.resortName}}</span>&nbsp;&nbsp;&nbsp;
      <span class="tag-details"><translate>Check in</translate>: </span> <span class="name-details">{{ model.params.checkIn }}</span>&nbsp;&nbsp;&nbsp;
      <span class="tag-details"><translate>No. nights</translate>: </span> <span class="name-details">{{duration}}</span>&nbsp;&nbsp;&nbsp;
      <span v-for="(room, index) in params.rooms" :key="index" class="mx-2">
        <span class="tag-details"><translate>Room</translate> {{index + 1 }} - </span>
        <span>{{room.adults}} </span><span class="name-details"> <translate>adults</translate> </span>
        <span v-if="room.ages && room.ages.length" class="name-details">, {{ room.ages.length }} <translate>children</translate></span>
      </span>
      <hr class="my-1"/>
      <small class="float-right">
          <b v-translate>generated by</b> -
          <span class="name-details"> {{userData.fname}} {{userData.lname}}</span>
      </small>
    </b-col>
  </b-row>
</template>

<script>
import moment from 'moment'
import auth from 'b2b-common/mixins/auth'
import model from '../services/model'

export default {
  props: ['params'],
  mixins: [auth],
  data () {
    return {
      model
    }
  },
  computed: {
    duration () {
      return moment(model.params.checkOut, 'DD-MM-YYYY').startOf('day').diff(moment(model.params.checkIn, 'DD-MM-YYYY').startOf('day'), 'days')
    }
  }
}
</script>
<style scoped>
.print-only {
  display: none!important;
}
</style>
